import React, { useEffect, useRef } from 'react';

export default function CodeRain() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const resizeCanvas = () => {
      const parent = canvas.parentElement;
      if (parent) {
        canvas.width = parent.clientWidth;
        canvas.height = parent.clientHeight;
      } else {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Code characters mixed with brand name letters
    const chars = "01<>[]{}/\\+=:;*&^%#@!WESITEXFLUIDTECH";
    const charArray = chars.split("");

    const fontSize = 14;
    const columns = Math.floor(canvas.width / fontSize) + 1;
    const rainDrops: number[] = Array(columns).fill(1).map(() => Math.floor(Math.random() * -100));

    const draw = () => {
      // Semi-transparent brand-dark background to create trails
      ctx.fillStyle = 'rgba(2, 6, 23, 0.08)'; 
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = `${fontSize}px monospace`;

      for (let i = 0; i < rainDrops.length; i++) {
        const text = charArray[Math.floor(Math.random() * charArray.length)];
        const dropVal = rainDrops[i];
        if (text === undefined || dropVal === undefined) continue;

        const x = i * fontSize;
        const y = dropVal * fontSize;

        // Brand-matching glow colors (purple rain with cyan sparks)
        const rand = Math.random();
        if (rand > 0.98) {
          ctx.fillStyle = '#06b6d4'; // Cyan spark
        } else if (rand > 0.85) {
          ctx.fillStyle = '#ffffff'; // White/gray coding text
        } else {
          ctx.fillStyle = 'rgba(139, 92, 246, 0.55)'; // Deep purple trail
        }

        ctx.fillText(text, x, y);

        if (y > canvas.height && Math.random() > 0.975) {
          rainDrops[i] = 0;
        } else {
          rainDrops[i] = dropVal + 1;
        }
      }
    };

    const interval = setInterval(draw, 33);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return <canvas ref={canvasRef} className="absolute inset-0 w-full h-full block pointer-events-none mix-blend-screen z-20" />;
}
